import React, { useMemo } from 'react';
import { history } from '../../../../store/appStore';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formatDate } from '../../../../utils/dates/date.utils';
import { YYYY_MM_DD } from '../../../../utils/dates/dateFormats.utils';

//ACTION CREATORS
import { idProofing, clearEDESearch } from '../../actions/actionCreators';

//Components
import IdProof from './idProof';

import { methods } from '../../../common/form/constants/validator';

import { configs } from '../../../../constants/configs/configs';
import { ALL_DOCUMENT_TYPES } from '../../constants/constants';
import {
    formatNumberToSSN,
    formatNumberToAlienNumber,
    removeFormat
} from '../../../../utils/miscellaneous/formatNumber';
import { useOutletContext } from 'react-router-dom';


const IdProofingContainer = ( props) => {

    const outletContextProps = useOutletContext();
    const mergedProps = { ...outletContextProps, ...props };

    const {
        actions,
        values,
        handleChange,
        handleBlur,
        handleFocus,
        errors,
        resetErrors,
        setFieldErrors,
        environment: {
            stateCode
        },
        touched,
        validate,
    } = mergedProps;

    const { endpoints, routes } = configs;
    const fieldErrors = [];

    const inputsToValidate = ['attested', 'firstName', 'lastName', 'dob_name', 'documentType', 'documentNumber', 'method'];

    Object.entries(errors).forEach(([key, errors]) => {
        if (!inputsToValidate.includes(key)) return;

        if (errors) {
            fieldErrors.push(...errors);
        }

    });

    const checkDocumentInformation = useMemo(() => methods.validateDocument([values.documentType, values.documentNumber]), [values.documentType, values.documentNumber]);

    const handleSSNBlur = (number) => {
        let formattedNumber = number;
        if (values.documentType === ALL_DOCUMENT_TYPES.SSN && methods.validateDocument([ALL_DOCUMENT_TYPES.SSN, number]) ) {
            if((/^\d+$/.test(number)) && number.length === 9) {
                formattedNumber = formatNumberToSSN(number);
            }
        } else if(values.documentType === ALL_DOCUMENT_TYPES.EMPLOYMENT_AUTHORIZATION_DOCUMENT && methods.validateDocument([ALL_DOCUMENT_TYPES.EMPLOYMENT_AUTHORIZATION_DOCUMENT, number]) ) {
            if((/^\d+$/.test(number)) && number.length === 9) {
                formattedNumber = formatNumberToAlienNumber(number);
            }
        }
        handleBlur({ target: { value: formattedNumber, name: 'documentNumber' } });
    };
    const fieldsToValidate = ['attested', 'firstName', 'lastName', 'dob_name', 'documentType', 'documentNumber', 'method'];
    const filteredTouchedFields = Object.keys(touched)
        .filter(key => fieldsToValidate.includes(key))
        .reduce((obj, key) => {
            obj[key] = touched[key];
            return obj;
        }, {});


    const handleSubmit = () => {

        const touchedFields = Object.entries(filteredTouchedFields).reduce((acc, [key, value]) => {
            if(!value) {
                acc[key] = values[key];
            } else {
                const errObj = validate({ [key]: values[key] });
                if(Object.keys(errObj).length) {
                    acc[key] = values[key];
                }
            }
            return acc;
        }, {});

        const errs = validate(touchedFields);
        if( Object.keys(errs).length) return;

        if( fieldErrors.length === 0 && checkDocumentInformation ) {
            values.ssn = values.documentType === ALL_DOCUMENT_TYPES.SSN ? values.documentNumber : '';
            values.dob = values.dob_name;
            let valuesToSubmit = {
                ...values,
                documentType: ((values.documentType).toUpperCase()).replace(/[-'\s.]/g, '_').replace(/[(),]/g,''),
                documentNumber: removeFormat(values.documentNumber),
                method: values.method && (values.method === 'Over Phone' ? 'TELEPHONE' : ((values.method).toUpperCase()).replace(' ', '_')),
                birthDate: formatDate(values.dob_name, YYYY_MM_DD),
                identityProofId: null
            };
            delete valuesToSubmit.dob;
            delete valuesToSubmit.dob_name;
            delete valuesToSubmit.ssn;
            delete valuesToSubmit.email;
            delete valuesToSubmit.city;
            delete valuesToSubmit.zipCode;
            delete valuesToSubmit.identityProofId;

            actions.idProofing(endpoints.EDE_ID_PROOFING_ENDPOINT, {
                ...valuesToSubmit,
                history,
                redirectUrl: routes.EDE_SEARCH_PAGE
            });
            actions.clearEDESearch();
            setFieldErrors(false);
            resetErrors();
            values.email = '';
            values.zipCode = '';
            values.city = '';
            delete errors.email;
            delete errors.zipCode;
            delete errors.city;
        }
    };

    return (
        <IdProof { ...{ values, handleChange, handleBlur, handleFocus, handleSubmit, handleSSNBlur, fieldErrors, stateCode } } />
    );

};

const mapStateToProps = state => ({
    spinner: state.common.spinner,
    environment: state.common.environment,
    idProofingResponse: state.edeSearch.response
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        idProofing,
        clearEDESearch
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(IdProofingContainer);